<template>
    <div class="gastos-multas">
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="xl" ref="consolidado" title="Consolidado">
            <div class="d-flex flex-column align-items-center consolidado">
                <h3>Consolidado</h3>
                <div>
                    <div class="jugueteria">
                        <center><h4>Jugueteria</h4></center>
                        <div>
                            <div v-for="(subnomina, index) in subnominasJugueteria" :key="index" class="consolidado-item">
                                <label for="">Desde{{ " - " + subnomina.fechaInicial.split($store.state.constants.SEPARETOR)[0] }}</label>
                                <label for="">Hasta{{ " - " + subnomina.fechaFinal.split($store.state.constants.SEPARETOR)[0] }}</label>
                                <label for="">Pendiente <span>{{ PriceForm(subnomina.pendiente) }}</span></label>
                                <label for="" v-if="subnomina.ventas.length > 0">Compras: </label>
                                <div v-for="(venta, index) in subnomina.ventas" :key="index">
                                    <label for="">{{ "-" + venta.producto }} <span>{{ PriceForm(venta.total) }}</span></label>
                                </div>
                                <label for="">Anticipo <span>{{ PriceForm(subnomina.anticipo) }}</span></label>
                                <label for="">Abono <span>{{ PriceForm(subnomina.abono) }}</span></label>
                            </div>
                        </div>
                    </div>
                    <div class="variedades">
                        <center><h4>Variedades</h4></center>
                        <div>
                            <div v-for="(subnomina, index) in subnominasVariedades" :key="index">
                                <label for="">Desde{{ " - " + subnomina.fechaInicial.split($store.state.constants.SEPARETOR)[0] }}</label>
                                <label for="">Hasta{{ " - " + subnomina.fechaFinal.split($store.state.constants.SEPARETOR)[0] }}</label>
                                <label for="">Pendiente <span>{{ PriceForm(subnomina.pendiente) }}</span></label>
                                <label for="" v-if="subnomina.ventas.length > 0">Compras: </label>
                                <div v-for="(venta, index) in subnomina.ventas" :key="index">
                                    <label for="">{{ "-" + venta.producto }} <span>{{ PriceForm(venta.total) }}</span></label>
                                </div>
                                <label for="">Anticipo <span>{{ PriceForm(subnomina.anticipo) }}</span></label>
                                <label for="">Abono <span>{{ PriceForm(subnomina.abono) }}</span></label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="addMulta" :title="'Agregar egreso a '+ modelName">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h3>Agregar Egreso</h3>
                <div>
                    <label for="">Valor</label>
                    <input type="number" name="" id="" v-model="monto">
                </div>
                <select name="" id="" v-model="egresoType">
                    <option :value="egreso.name" v-for="(egreso, index) in egresosList" :key="index">{{ egreso.name }}</option>
                </select>
                <div>
                    <label for="">Motivo</label>
                    <textarea name="" id="" cols="30" rows="10" v-model="motivo"></textarea>
                </div>
                <button @click="createMulta">Agregar Multa</button>
            </div>
        </b-modal>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="all_multas" :title="'Lista de multas de '+ modelName">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <div>
                    <center>
                        <h3>Multas</h3>
                        <div ref="multas_scroll">
                            <table>
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Fecha</th>
                                        <th>Ingreso</th>
                                        <th>Modelo</th>
                                        <th>Motivo</th>
                                        <th>Valor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(multa, index) in allMultasList" :key="index" :class="{'selectModel': multa.active}" v-on:click="selectModel(index)">
                                        <td>{{multa.created_at.split($store.state.constants.SEPARETOR)[0]}}</td>
                                        <td>{{multa.who}}</td>
                                        <td>{{multa.to}}</td>
                                        <td>{{multa.motivo}}</td>
                                        <td>{{multa.valor}}</td>
                                        <td :class="{'no-pay': !multa.flag, 'pay': multa.flag}">{{multa.flag === 0 ? 'NO PAGA' : 'PAGADA'}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </center>
                </div>
            </div>
        </b-modal>
        <div class="owe-multas">
            <div class="totals">
                <div class="grantotal">
                    <div>
                        <h3 for="">Total  <span>{{GranTotalPrice}}</span></h3>
                    </div>
                </div>
                <div class="grantotal">
                    <div>
                        <h3 for="">Pendiente <span>{{TotalPendingPrice}}</span></h3>
                    </div>
                </div>
            </div>
            <div class="owe">
                <div class="tienda">
                    <div>
                        <h4 for="">Mecato</h4>
                        <h3><span>{{TotalTiendaPrice}}</span></h3>
                    </div>
                </div>
                <div class="multas">
                    <div>
                        <h4 for="">Jugueteria</h4>
                        <h3><span>{{TotalJugueteriaPrice}}</span></h3>
                    </div>
                </div>
                <div class="otros">
                    <div>
                        <h4 for="">Variedades</h4>
                        <h3><span>{{TotalVariedadesPrice}}</span></h3>
                    </div>
                </div>
            </div>
            <div class="multas">
                <div>
                    <center>
                        <h3>Egresos</h3>
                        <div>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Ingreso</th>
                                        <th>Modelo</th>
                                        <th>Motivo</th>
                                        <th>Valor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(multa, index) in multasList" :key="index" :class="{'selectModel': multa.active}" v-on:click="selectModel(index)">
                                        <td>{{multa.created_at}}</td>
                                        <td>{{multa.who}}</td>
                                        <td>{{multa.to}}</td>
                                        <td>{{multa.motivo}}</td>
                                        <td>{{multa.valor}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="controls">
                            <button @click="addMulta">Agregar egreso</button>
                            <button @click="allMultas">Ver todas los egresos</button>
                            <button @click="deleteMulta">Eliminar</button>
                        </div>
                    </center>
                </div>
            </div>
        </div>
        <div class="tables-store">
            <div class="tienda">
                <div>
                    <center>
                        <h3>Tienda</h3>
                        <div>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Producto</th>
                                        <th>Cantidad</th>
                                        <th>Valor Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(product, index) in storeList" :key="index">
                                        <td>{{product.created_at}}</td>
                                        <td>{{product.name}}</td>
                                        <td>{{product.cantidad}}</td>
                                        <td>{{product.total}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </center>
                </div>
            </div>
            <div class="otros">
                <div>
                    <button @click="$refs.consolidado.show()">Consolidado</button>
                    <center>
                        <h3>Jugueteria y variedades</h3>
                        <div>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Producto</th>
                                        <th>Cantidad</th>
                                        <th>Valor Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(product, index) in abonoList" :key="index">
                                        <td>{{product.created_at}}</td>
                                        <td>{{product.name}}</td>
                                        <td>{{product.cantidad}}</td>
                                        <td>{{product.total}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </center>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/api'
import Price from '../../utils/ConvertPriceNumber'

export default {
    name: 'gastos-multas',
    data() {
        return {
            TotalTienda: 0,
            subnominasJugueteria: [],
            subnominasVariedades: [],
            TotalMultas: 0,
            TotalVariedades: 0,
            TotalJugueteria: 0,
            TotalPending: 0,
            multasList: [],
            storeList: [],
            abonoList: [],
            allMultasList: [],
            GranTotal: 0,
            modelName: null,
            monto: 0,
            egresoType: null,
            motivo: null,
            multaIDselect: null,
            limit: 30,
            offset: 0,
            egresosList: [],
            limitJugueteria: 5,
            offsetJugueteria: 0,
            busyJugueteria: false,
            listEndJugueteria: false,
            itemFlagJugueteria: false,
            limitVariedades: 5,
            offsetVariedades: 0,
            busyVariedades: false,
            listEndVariedades: false,
            itemFlagVariedades: false
        }
    },
    computed: {
        GranTotalPrice: {
            get() {
                return Price(this.GranTotal)
            }
        },
        TotalTiendaPrice: {
            get() {
                return Price(this.TotalTienda)
            }
        },
        TotalMultasPrice: {
            get() {
                return Price(this.TotalMultas)
            }
        },
        TotalVariedadesPrice: {
            get() {
                return Price(this.TotalVariedades)
            }
        },
        TotalJugueteriaPrice: {
            get() {
                return Price(this.TotalJugueteria)
            }
        },
        TotalPendingPrice: {
            get() {
                return Price(this.TotalPending)
            }
        }
    },
    beforeMount() {
        this.$root.$emit('changeModel', this.$route.name)
    },
    methods: {
        PriceForm(number) {
            return Price(number)
        },
        getConsolidadoJugueteria() {
            API.getConsolidadoJugueteria(this.limitJugueteria, this.offsetJugueteria, this.$route.params.admin_id)
                .then((res) => {
                    if (res.length === 0) {
                        return
                    }
                    res.forEach(element => {
                        this.subnominasJugueteria.push(element)
                    })
                    this.offsetJugueteria += this.limitJugueteria
                    this.getConsolidadoJugueteria()
                })
        },
        getConsolidadoVariedades() {
            API.getConsolidadoVariedades(this.limitVariedades, this.offsetVariedades, this.$route.params.admin_id)
                .then((res) => {
                    if (res.length === 0) {
                        return
                    }
                    res.forEach(element => {
                        this.subnominasVariedades.push(element)
                    })
                    this.offsetVariedades += this.limitVariedades
                    this.getConsolidadoVariedades()
                })
        },
        handleScroll() {
            if (this.$refs.multas_scroll.scrollHeight - this.$refs.multas_scroll.offsetHeight === this.$refs.multas_scroll.scrollTop && this.allMultasList.length === this.offset) {
                this.allMultas()
            }
        },
        getEgresosTypeList() {
            API.getEgresosTypeList()
                .then((res) => {
                    this.egresosList = res
                })
        },
        deleteMulta() {
            API.deleteModelMulta(this.multaIDselect)
                .then((res) => {
                    this.GranTotal = this.GranTotal - this.TotalMultas
                    this.getMultasList()
                    this.getOweMultas()
                })
        },
        allMultas() {
            this.$refs.all_multas.show()
            API.getAllMultasListByModel(this.$route.params.admin_id, this.limit, this.offset)
                .then((res) => {
                    res.map(multa => { this.allMultasList.push(multa) })
                    this.offset += this.limit
                    this.$refs.multas_scroll.addEventListener('scroll', this.handleScroll)
                })
        },
        addMulta() {
            this.$refs.addMulta.show()
        },
        createMulta() {
            var info = {
                who: this.$store.state.user.id,
                to: this.$route.params.admin_id,
                valor: this.monto,
                motivo: this.motivo,
                egreso: this.egresoType
            }
            API.createMultaByModel(info)
                .then((res) => {
                    this.$refs.addMulta.hide()
                    this.getMultasList()
                    this.GranTotal = this.GranTotal - this.TotalMultas
                    this.getOweMultas()
                })
        },
        selectModel(index) {
            this.multasList.map((multa, i) => { if (i !== index) multa.active = false })
            this.multasList[index].active = !this.multasList[index].active
            this.multaIDselect = this.multasList[index].id
        },
        getOweStore() {
            API.getOweStoreByModel(this.$route.params.admin_id)
                .then((res) => {
                    this.TotalTienda = res.cantidad
                    this.GranTotal = this.GranTotal + res.cantidad
                })
        },
        getOweVariedades() {
            API.getOweVariedadesByModel(this.$route.params.admin_id)
                .then((res) => {
                    this.TotalVariedades = res.cantidad
                    this.GranTotal = this.GranTotal + res.cantidad
                })
        },
        getOweJugueteria() {
            API.getOweJugueteriaByModel(this.$route.params.admin_id)
                .then((res) => {
                    this.TotalJugueteria = res.cantidad
                    this.GranTotal = this.GranTotal + res.cantidad
                })
        },
        getOweMultas() {
            API.getOweMultasByModel(this.$route.params.admin_id)
                .then((res) => {
                    this.TotalMultas = res.cantidad
                    this.GranTotal = this.GranTotal + res.cantidad
                })
        },
        getMultasList() {
            API.getMultasListByModel(this.$route.params.admin_id)
                .then((res) => {
                    this.multasList = res.slice(0).reverse().map(item => {
                        return {
                            created_at: item.created_at.split(this.$store.state.constants.SEPARETOR)[0],
                            who: item.who,
                            to: item.to,
                            motivo: item.motivo,
                            valor: Price(item.valor),
                            whoId: item.whoId,
                            toId: item.toId,
                            active: false,
                            id: item.id
                        }
                    })
                })
        },
        getStoreList() {
            API.getStoreListByModel(this.$route.params.admin_id)
                .then((res) => {
                    this.storeList = res.slice(0).reverse().map(item => {
                        return {
                            created_at: item.created_at.split(this.$store.state.constants.SEPARETOR)[0],
                            name: item.name,
                            cantidad: item.cantidad,
                            id: item.id,
                            total: Price(item.total)
                        }
                    })
                })
        },
        getAbonoList() {
            API.getAbonoListByModel(this.$route.params.admin_id)
                .then((res) => {
                    this.abonoList = res.slice(0).reverse().map(item => {
                        return {
                            created_at: item.created_at.split(this.$store.state.constants.SEPARETOR)[0],
                            name: item.name,
                            cantidad: item.cantidad,
                            id: item.id,
                            total: Price(item.total)
                        }
                    })
                })
        },
        getPendingCharges() {
            API.getPendingChargesByModel(this.$route.params.admin_id)
                .then((res) => {
                    if (res.cantidad === undefined) {
                        return
                    }
                    this.TotalPending = res.cantidad
                    this.GranTotal += res.cantidad
                })
        },
        getStagename() {
            API.getModelStagename(this.$route.params.admin_id)
                .then((res) => {
                    this.modelName = res.stagename
                })
        }
    },
    mounted() {
        this.getOweStore()
        this.getOweVariedades()
        this.getOweJugueteria()
        this.getOweMultas()
        this.getPendingCharges()
        this.getMultasList()
        this.getStoreList()
        this.getAbonoList()
        this.getStagename()
        this.getEgresosTypeList()
        this.getConsolidadoJugueteria()
        this.getConsolidadoVariedades()
    }
}
</script>

<style scoped>
    .gastos-multas {
        width: 100%;
        height: 78vh;
        background-color: #cdcdcd;
        display: flex;
    }
    .gastos-multas > .owe-multas {
        display: block;
        width: 51%;
        padding: 20px;
        height: 100%;
    }
    .gastos-multas > .owe-multas > .totals {
        height: 5%;
        display: flex;
    }
    .gastos-multas > .owe-multas > .totals > .grantotal{
       width: 50%;
       height: 100%;
       padding: 0px 10px 0px 10px;
    }
    .gastos-multas > .owe-multas > .totals > .grantotal > div{
       background-color: #e0b059;
       text-align: center;
       color: #fff;
       border-radius: 20px;
       padding: 0px 10px 0px 10px;
       height: 100%;
       border-style: outset;
    }
    .gastos-multas > .owe-multas > .totals > .grantotal > div > h3{
       background-color: #e0b059;
       text-align: center;
       color: #fff;
       border-radius: 20px;
       font-size: 20px;
    }
    .gastos-multas > .owe-multas > .owe {
        display: flex;
        height: 20%;
    }
    .gastos-multas > .owe-multas > .owe > .tienda{
        width: 33.33333%;
        height: 100%;
        padding: 10px;
        position: relative;
    }
    .gastos-multas > .owe-multas > .owe > .multas{
        width: 33.33333%;
        height: 100%;
        padding: 10px;
        position: relative;
    }
    .gastos-multas > .owe-multas > .owe > .otros{
        width: 33.33333%;
        height: 100%;
        padding: 10px;
        position: relative;
    }
    .gastos-multas > .owe-multas > .owe > .tienda > div{
        background-color: #63b763;
        border-radius: 20px;
        border-style: outset;
    }
    .gastos-multas > .owe-multas > .owe > .multas > div{
        background-color: #e0b059;
        border-radius: 20px;
        border-style: outset;
    }
    .gastos-multas > .owe-multas > .owe > .otros > div{
        background-color: #b78863;
        border-radius: 20px;
        border-style: outset;
    }
    .gastos-multas > .owe-multas > .owe > div > div{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 90%;
        padding: 10px;
    }
    .gastos-multas > .owe-multas > .owe > div > div > h3{
        float: left;
        color: #fff;
    }
    .gastos-multas > .owe-multas > .owe > div > div > h4{
        color: #fff;
    }
    .gastos-multas > .owe-multas > .owe > div > div > h3 > span{
        font-size: 28px;
        color: #000;
    }
    .gastos-multas > .owe-multas > .multas {
        width: 100%;
        height: 56vh;
    }
    .gastos-multas > .owe-multas > .multas > div{
        width: 100%;
        height: 100%;
        background-color:#8363b7;
        border-radius: 20px;
        padding: 20px;
        border-style: outset;
    }
    .gastos-multas > .owe-multas > .multas > div > center {
        height: 100%;
    }
    .gastos-multas > .owe-multas > .multas > div > center >h3 {
        color: #fff;
        font-weight: bold;
    }
    .gastos-multas > .owe-multas > .multas > div > center > div {
        margin-top: 20px;
        padding: 10px;
        height: 70%;
        overflow-y: auto;
    }
    .gastos-multas > .owe-multas > .multas > div > center > div > table > thead > tr > th{
        padding: 10px 30px 10px 30px;
        background-color: #63b763;
        border-style: inset;
    }
    .gastos-multas > .owe-multas > .multas > div > center > div > table > tbody > .selectModel {
        background-color: #63b763;
    }
    .gastos-multas > .owe-multas > .multas > div > center > div > table > tbody > tr > td{
        padding: 10px 10px 10px 10px;
        border-style: inset;
        color: #fff;
    }
    .gastos-multas > .owe-multas > .multas > div > center > .controls{
        height: auto;
    }
    .gastos-multas > .owe-multas > .multas > div > center > .controls > button{
        margin: auto;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 180px;
        height: 40px;
        border-radius: 30px;
    }
    .gastos-multas > .tables-store {
        width: 49%;
        height: 78vh;
    }
    .gastos-multas > .tables-store > .otros, .tienda{
        width: 100%;
        height: 50%;
        padding-right: 20px;
        padding-top: 20px;
    }
    .gastos-multas > .tables-store > .tienda > div {
        background-color: #63b1b7;
        width: 100%;
        height: 95%;
        border-radius: 20px;
        padding: 20px;
        border-style: outset;
    }
    .gastos-multas > .tables-store > .otros > div{
        background-color: #63b763;
        width: 100%;
        height: 95%;
        border-radius: 20px;
        padding: 20px;
        border-style: outset;
    }
    .gastos-multas > .tables-store > .tienda > div > center {
        height: 100%;
    }
    .gastos-multas > .tables-store > .tienda > div > center > h3 {
        color: #fff;
        font-weight: bold;
    }
    .gastos-multas > .tables-store > .tienda > div > center > div {
        height: 80%;
        overflow-y: auto;
    }
    .gastos-multas > .tables-store > .tienda > div > center > div > table > thead > tr > th {
        padding: 10px 20px 10px 20px;
        background-color: #63b763;
        border-style: inset;
    }
    .gastos-multas > .tables-store > .tienda > div > center > div > table > tbody > tr > td {
        padding: 10px 10px 10px 10px;
        border-style: inset;
    }
    .gastos-multas > .tables-store > .otros > div > button {
        margin: auto;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 180px;
        height: 40px;
        border-radius: 30px;
    }
    .gastos-multas > .tables-store > .otros > div > center > h3 {
        color: #fff;
        font-weight: bold;
    }
    .gastos-multas > .tables-store > .otros > div > center {
        height: 100%;
    }
    .gastos-multas > .tables-store > .otros > div > center > h3 {
        color: #fff;
        font-weight: bold;
    }
    .gastos-multas > .tables-store > .otros > div > center > div {
        height: 80%;
        overflow-y: auto;
    }
    .gastos-multas > .tables-store > .otros > div > center > div > table > thead > tr > th {
        padding: 10px 20px 10px 20px;
        background-color: #63b763;
        border-style: inset;
    }
    .gastos-multas > .tables-store > .otros > div > center > div > table > tbody > tr > td {
        padding: 10px 10px 10px 10px;
        border-style: inset;
    }
    .info-wrapper > h3 {
        color: #000;
        margin-bottom: 40px;
        margin-top: 10px;
    }
    .info-wrapper > div {
        display: contents;
    }
    .info-wrapper > div > label {
        color: #000;
        font-weight: bold;
        text-align: center;
    }
    .info-wrapper > div > input, textarea {
        width: 350px;
        border-style: double;
        text-align: center;
        border-radius: 25px;
        margin-bottom: 25px;
    }
    .info-wrapper > button {
        margin: auto;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 180px;
        height: 40px;
        border-radius: 30px;
    }
    .info-wrapper > div > center {
        height: 500px;
        overflow-y: auto;
        background-color: #e0b059;
        padding: 30px;
        color: #000;
        border-radius: 20px;
    }
    .info-wrapper > div > center > h3 {
        margin-top: 30px;
        margin-bottom: 30px;
    }
    .info-wrapper > div > center > div {
        height: 300px;
        overflow-y: auto;
        padding: 20px;
    }
    .info-wrapper > div > center > div > table > thead > tr > th{
        width: 200px;
        padding-left: 20px;
        padding-right: 20px;
        border-style: outset;
    }
    .info-wrapper > div > center > div > table > tbody > tr > td{
        padding-left: 20px;
        padding-right: 20px;
        border-style: outset;
    }
    .info-wrapper > div > center > div > table > tbody > tr > .pay{
       background-color: #63b763;
    }
    .info-wrapper > div > center > div > table > tbody > tr > .no-pay{
       background-color: #b78863;
    }
    .consolidado {
        display: flex;
    }
    .consolidado > div {
        font-size: 20px;
        width: 50%;
    }
    .consolidado > div > div > div {
        height: auto;
        width: 100%;
    }
    .consolidado > div > div > div > div {
        border-style: groove;
        width: 100%;
    }
    .consolidado > div > div > div > div > label{
        width: 100%;
        font-weight: bold;
    }
    .consolidado > div > div > div > div > label > span{
        font-weight: normal;
    }
</style>



// WEBPACK FOOTER //
// src/components/AdminsProfiles/AdminGastosMultas.vue